import client from "@/api";

export const getJobsWithContract = async () => {
  return await client.get("/jobs/with-contract");
};

export const getJobBoardByJobID = async (jobID, submissionID) => {
  return await client.get(`/jobs/board/job/${jobID}/submission/${submissionID}`);
};

export const saveJobBoardByJobID = async (jobID, payload) => {
  return await client.post(`/jobs/board/job/${jobID}`, payload);
};
